import { useState } from 'react';

import {
  Box,
  AppBar,
  Toolbar,
  Container,
  IconButton,
  useMediaQuery
} from '@mui/material';
import Link from 'next/link';
import { useTheme } from '@mui/system';
import loadable from '@loadable/component';
import MenuIcon from '@mui/icons-material/Menu';

import Image from 'features/core/Image';
import DesktopList from './DesktopList';

export default function Navigation() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const isMd = useMediaQuery(() => theme.breakpoints.up('md'));
  const SwipeableMenu = !isMd ? (
    loadable(() => import('./SwipeableMenu'))
  ) : (
    <></>
  );

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <AppBar position="fixed" elevation={0} color="inherit">
      <Container>
        <Toolbar component="nav" disableGutters>
          <Box>
            <Link href="/" passHref>
              <a>
                <Image
                  priority
                  width={205}
                  height={50}
                  layout="fixed"
                  alt="Khatabook"
                  src={`${process.env.NEXT_PUBLIC_ASSET_PREFIX}/kb-net/images/logo.svg`}
                />
              </a>
            </Link>
          </Box>
          {!isMd ? (
            <IconButton size="large" onClick={handleOpen}>
              <MenuIcon fontSize="large" />
            </IconButton>
          ) : (
            <DesktopList />
          )}
        </Toolbar>
      </Container>
      {!isMd && (
        <SwipeableMenu
          open={open}
          handleOpen={handleOpen}
          handleClose={handleClose}
        />
      )}
    </AppBar>
  );
}
